import React from 'react';
import { hydrate, render } from "react-dom";
import './styles/style.css';
import Bootstrap from './Bootstrap';
//import registerServiceWorker from './registerServiceWorker';
import "array-findindex-polyfill";
import arrayFind from "array.prototype.find";
import "string.prototype.startswith";
import "array-from";
import "string.prototype.includes";

import "picturefill";

arrayFind.shim();

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
    hydrate(<Bootstrap />, rootElement);
} else {
    render(<Bootstrap />, rootElement);
}

//registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js